import { combineReducers, configureStore } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import generalReducer, { setCurrentPage } from './generalSlice'
import authReducer from './authSlice'
import filtersReducer from './filtersSlice'
import { persistReducer } from 'redux-persist';
import generalOptionsSlice from './generalOptionsSlice'

const reducers = combineReducers({
    general: generalReducer,
    auth: authReducer,
    filters: filtersReducer,
    generalOptions: generalOptionsSlice
});

const persistConfig = {
  key: 'erespiroconnect',
  storage
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
  devTools: true
})

export const resetCurrentPage = () => {
  store.dispatch(setCurrentPage(''));
  return null;
}
